import React from "react";
import { Iprops } from "./savecartpopupinterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { ModalPopup } from "../../CommonComponent";
import Alerts from "../../Alerts";

const SaveCartPopUp = (props: Iprops) => {
    const { t } = useTranslation();

    const title = props?.isQuote ? t(RESOURCE.MyK_Label_ShoppingCart_Parts_List) : t(RESOURCE.MyK_Label_ShoppingCart_Save_Cart_as_Parts_List);
    const alertMsg = props?.isQuote ? t(RESOURCE.MyK_Label_ShoppingCart_Parts_List_Name_Is_Required) : t(RESOURCE.MyK_Label_ShoppingCart_Shopping_List_Name_Is_Required);
    const nameLabel = props?.isQuote ? t(RESOURCE.MyK_Label_ShoppingCart_Parts_List_Name) : t(RESOURCE.MyK_Label_ShoppingCart_Shopping_List_Name)

    return (
        <ModalPopup
            ModalPopupTitle={title}
            ModalPopupType="smaller"
            closeModalPopup={props?.closePopup}
        >
            <div className="savecart_popup">
                {
                    props?.isShowAlert && <Alerts
                        messageAlert={alertMsg}
                        alertType={'error'}
                        time={3000}
                        onClose={() => props?.handleIsShowAlert(false)} />
                }
                <div className="mb-1">
                    <label className="shoppinglist_label">{nameLabel}<sup>*</sup></label>
                </div>
                <div className="mb-3">
                    <input
                        className="shoppinglist_input"
                        onChange={(e: any) => props?.onNameChange(e?.target?.value ?? '')}
                        value={props?.saveCartDetails?.shoppingListName ?? ''}
                    ></input>
                </div>
                <div className="partlist_select">
                    <div className="mb-1">
                        <label><input
                            type="radio"
                            id="cust"
                            className="mr-3 partlist_check"
                            checked={props?.saveCartDetails?.selectedListType === 'cust'}
                            onChange={(e) => props?.handleRadioChange(e)}
                            name="savecart"></input><span className="partslistlabel">{t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_List_Customer)}</span></label>
                    </div>
                    <div>
                        <label><input
                            type="radio"
                            id="user"
                            className="mr-3 partlist_check"
                            checked={props?.saveCartDetails?.selectedListType === 'user'}
                            onChange={(e) => props?.handleRadioChange(e)}
                            name="savecart"></input><span className="partslistlabel">{t(RESOURCE.MyK_Label_ShoppingCart_Shared_Parts_List_User)}</span></label>
                    </div>
                </div>
                <div className="partlist_footer mt-3">
                    <button className="savebtn mr-2" onClick={() => props?.onSaveChanges()} title={t(RESOURCE.MyK_Label_Save)}><span className="fa fa-floppy-o mr-1"></span>{t(RESOURCE.MyK_Label_Save)}</button>
                    <button className="cancelbtn" onClick={() => props?.closePopup()} title={t(RESOURCE.MyK_Label_Cancel)}><span className="fa fa-times mr-1"></span>{t(RESOURCE.MyK_Label_Cancel)}</button>
                </div>
            </div>
        </ModalPopup>
    )
}

export default SaveCartPopUp;